import React from 'react';

import K from '../../k';
import Icon from '../icon';

const Tag = ({closable = false, closeIcon, onClose, onClick, color = K.colors.darkGray, children, style}) => {
  const styles = {
    tag: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      width: 'fit-content',
      height: 'fit-content',
      borderRadius: 5,
      paddingTop: K.spacing - 7,
      paddingBottom: K.spacing - 7,
      paddingLeft: K.spacing - 9,
      paddingRight: K.spacing - 9,
      backgroundColor: color,
      ...style
    },
    closeIcon: {display: 'flex', alignItems: 'flex-end'}
  };

  return (
    <div className={'hoverable'} style={styles.tag} {...{onClick}}>
      {children}
      {closable && (
        <Icon style={styles.closeIcon} icon={closeIcon} onClick={onClose} name='close'/>
      )}
    </div>
  );
};

export default Tag;